import { render, staticRenderFns } from "./LabelsNew.vue?vue&type=template&id=1a32535c&scoped=true"
import script from "./LabelsNew.vue?vue&type=script&lang=js"
export * from "./LabelsNew.vue?vue&type=script&lang=js"
import style0 from "./LabelsNew.vue?vue&type=style&index=0&id=1a32535c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32535c",
  null
  
)

export default component.exports